/**
 * 应用环境检测工具函数
 * 用于检测当前环境是否在特定应用内运行
 */

/**
 * 检测是否在企业微信中
 */
export const isInWXWork = (): boolean => {
  const ua = navigator.userAgent.toLowerCase();
  return ua.match(/wxwork/i) !== null;
};

/**
 * 检测是否在微信中（不包括企业微信）
 */
export const isInWeixin = (): boolean => {
  const ua = navigator.userAgent.toLowerCase();
  return ua.match(/micromessenger/i) !== null && !isInWXWork();
};

/**
 * 检测是否在支付宝中
 */
export const isInAlipay = (): boolean => {
  const ua = navigator.userAgent.toLowerCase();
  return ua.indexOf('alipay') > -1;
};

/**
 * 检测是否在钉钉中
 */
export const isInDingTalk = (): boolean => {
  const ua = navigator.userAgent.toLowerCase();
  return ua.indexOf('dingtalk') > -1;
};

/**
 * 检测是否在原生App中
 */
export const isInApp = (): boolean => {
  return /GenchApp/.test(navigator.userAgent) || new URLSearchParams(location.search).get('inapp') === 'true';
};

export const getInAppPlatform = (): string => {
  return (new URLSearchParams(location.search).get('platform') || '').toLowerCase();
};

export const supportsNativeWeChatAuth = (): boolean => {
  if (!isInApp()) {
    return false;
  }

  const platform = getInAppPlatform();
  return !platform || platform === 'android' || platform === 'ios';
};

export const supportsNativeAlipayAuth = (): boolean => {
  if (!isInApp()) {
    return false;
  }

  const platform = getInAppPlatform();
  return !platform || platform === 'android' || platform === 'ios';
};

/**
 * 检测是否在任一应用中（微信、企业微信、支付宝、钉钉、原生App）
 */
export const isInAnyApp = (): boolean => {
  return isInWeixin() || isInWXWork() || isInAlipay() || isInDingTalk() || isInApp();
};

export const isInMobileApp = (): boolean => {
  return isInApp();
};